var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallMade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23.241,
    viewBox: "0 0 19 23.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{font-size:9px;font-family:Poppins-Bold, Poppins;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1383.718 -376.012)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(1383.718 396.253)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CSV")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1392.281 376.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M343.136,0H334.96a1.13,1.13,0,0,0,0,2.261h7.046V9.306a1.13,1.13,0,0,0,2.261,0V1.13A1.13,1.13,0,0,0,343.136,0Z",
    transform: "translate(-333.83 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M212.793.265a.9.9,0,0,0-1.279,0l-7.623,7.418a.9.9,0,1,0,1.279,1.279l7.622-7.418A.9.9,0,0,0,212.793.265Z",
    transform: "translate(-203.627 0)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMade);
export default __webpack_public_path__ + "static/media/CallMade.23879b455ae5258d16ad60a0583d5c2d.svg";
export { ForwardRef as ReactComponent };